import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import axios from 'src/app/Service/axios';
import { Draw } from 'ol/interaction';
import { Polygon } from "ol/geom";
import { Fill, Stroke, Style } from "ol/style";
import { XYZ } from "ol/source";
import { MapService } from 'src/app/Service/map.service';
import TileLayer from 'ol/layer/Tile';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Feature from "ol/Feature";
import BingMaps from "ol/source/BingMaps";
import * as olProj from 'ol/proj';

declare let $: any;

@Component({
  selector: 'app-tanker-customer-management',
  templateUrl: './tanker-customer-management.component.html',
  styleUrls: ['./tanker-customer-management.component.css']
})

export class TankerCustomerManagementComponent implements OnInit {
  lst_Clients = [];
  lst_Search = [];
  lst_ClientUsage = [];
  deliveryScheduleList: any = [];
  selectedItems: any = [];
  selectAll: boolean = false;
  tankerList: any = [];
  daysOfWeek = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'];
  map: any;
  draw: any;
  layers = [];
  source: any;
  vector: any;
  vectorLayer: any;
  polygonEvent: any;
  ismapCreate: boolean = false;
  private bOfflineMap: boolean = (<any>window).bOfflineMap;
  private strMapUrl: string = (<any>window).strMapUrl;


  mdl_Search: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

  });

  addUserForm: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iTanker_WaterClient: new FormControl(''),

    strName: new FormControl('', Validators.required),

    tiTanker_WaterClientUsage: new FormControl('', Validators.required),

    strTel: new FormControl(''),

    strAddress: new FormControl(''),

    iDeliveryLimit: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    strSDate: new FormControl('', Validators.required),

    strContractNumber: new FormControl(''),

    lstPoints: new FormControl([]),

    index: new FormControl(-1),

  });

  deliveryScheduleForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
    iTanker_WaterClient: ['', Validators.required],
    strSDate: ['', Validators.required],
    strEDate: ['', Validators.required],
    strDayName: ['', Validators.required],
    strTime: ['', Validators.required],
    iValue: ['', [Validators.required, Validators.min(1)]],
    strComment: ['']
  });

  assignTankerForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
    lstiTanker_DeliverySchedule: [[], Validators.required],
    strUnitID: ['', Validators.required]
  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private mapService: MapService,
  ) {

  }

  ngOnInit(): void {
    this.getClients();
    this.getClientUsage();
    this.getTanker()

  }

  ngAfterViewInit() {
    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });
  }

  getClients = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Tanker_WaterClient_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_Clients = res;
    this.lst_Search = res;

  }

  getClientUsage = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Tanker_WaterClientUsage_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_ClientUsage = res;
  }

  async openAddOrUpdateUserModal(item?: any, index?: any) {

    if (item) {

      const fullInfo = await this.getInfo(item);

      if (!fullInfo) return;

      Object.keys(fullInfo).forEach(key => {
        this.addUserForm.get(key)?.setValue(fullInfo[key]);
      });

      this.addUserForm.patchValue({
        index: index
      });

      $("#addOrUpdateUser_Modal").modal("show");
      this.initMap();
      setTimeout(() => {
        this.showPolygon((fullInfo as any).lstPoints)
      }, 800);
    }

    else {

      this.addUserForm.patchValue({

        iTanker_WaterClient: undefined,

        strName: '',

        tiTanker_WaterClientUsage: '',

        strTel: '',

        strAddress: '',

        iDeliveryLimit: '',

        strEDate: '',

        strSDate: '',

        strContractNumber: '',

        lstPoints: [],

        index: -1

      });

      this._other.markAllAsUnTouched(this.addUserForm);
      $("#addOrUpdateUser_Modal").modal("show");

      this.initMap();
      setTimeout(() => {
        this.showPolygon([]);
        this.map.setView(new View({
          center: olProj.fromLonLat([51.3833554, 35.6770113]),
          zoom: 13,
        }))
      }, 800);

    }

  }

  initMap() {

    setTimeout(() => {

      if (!this.ismapCreate) {

        this.source = new VectorSource({ wrapX: false });

        this.vector = new VectorLayer({
          source: this.source,
        });

        if (this.bOfflineMap) {

          this.layers.push(

            new TileLayer({

              source: new XYZ({

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' // 

              }),

            })

          );

        }

        else {

          const styles = [

            'AerialWithLabelsOnDemand',

          ];

          let i, ii;

          for (i = 0, ii = styles.length; i < ii; ++i) {

            this.layers.push(
              new TileLayer({
                visible: false,
                preload: Infinity,
                source: new BingMaps({
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                  imagerySet: styles[i],
                }),

              }),

            );

          }

          this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector);


        }

        this.map = new Map({

          layers: this.layers,

          target: 'clientsMap',

          view: new View({
            center: olProj.fromLonLat([51.3833554, 35.6770113]),
            zoom: 13,
          }),

        });

        this.ismapCreate = true;

      }

    }, 500);

    setTimeout(() => {
      //Handel Add Polygon
      this.vector.getSource().on('addfeature', (e: any) => {
        this.polygonEvent = e.feature;
        this.source.removeFeature(e.feature);
        this.source.removeFeature(this.polygonEvent);
        this.savePolygon();
      });
      const value = 'Polygon';
      this.draw = new Draw({
        source: this.source,
        type: value,
      });
      this.map.addInteraction(this.draw);
    }, 700);

  }

  savePolygon = async () => {

    var point = [] as any;

    this.draw.sketchLineCoords_.forEach((item: any, index: any) => {

      var data = this.mapService.transformCoordinates(item);

      point.push({ fLat: data[1], fLon: data[0] });

    });

    this._tooltip.showSuccess("محدوده با موفقیت ترسیم شد.");

    this.addUserForm.controls["lstPoints"].setValue(point);

    this.showPolygon(point);


  }

  showPolygon(point: any[]) {

    if (typeof (point) != 'object') return;

    // Remove the previous polygon

    if (this.addUserForm.get('lstPoints')?.value != '') {

      this.mapService.removeLayerByName('polygon', this.map);

    }

    if (this.vectorLayer) this.map.removeLayer(this.vectorLayer);

    if (point.length != 0) {

      var ring = [];

      for (let index = 0; index < point.length; index++) {

        ring.push([point[index].fLon, point[index].fLat]);

      }

      var polygon = new Polygon([ring]);

      polygon.transform('EPSG:4326', 'EPSG:3857');

      var feature = new Feature(polygon);

      var vectorSource = new VectorSource();

      vectorSource.addFeature(feature);

      var vectorLayer = new VectorLayer({

        source: vectorSource,

        name: 'polygon',

        style: new Style({

          stroke: new Stroke({

            color: 'red',

            width: 4,

            lineDash: [10, 20, 10, 20]

          }),

          fill: new Fill({

            color: 'rgba(0, 0, 255, 0)'

          })

        }),

      } as any);


      this.vectorLayer = vectorLayer;

      this.map.addLayer(vectorLayer);

      this.fitToAll(point);


    }

  }

  fitToAll(obj: any[]) {

    let maxLatitude = -Infinity;

    let maxLongitude = -Infinity;

    let minLatitude = Infinity;

    let minLongitude = Infinity;

    for (const item of obj) {

      if (item.fLat > maxLatitude) maxLatitude = item.fLat;

      if (item.fLon > maxLongitude) maxLongitude = item.fLon;

      if (item.fLat < minLatitude) minLatitude = item.fLat;

      if (item.fLon < minLongitude) minLongitude = item.fLon;
    }

    var model: any = {

      maxLatitude: maxLatitude,

      maxLongitude: maxLongitude,

      minLatitude: minLatitude,

      minLongitude: minLongitude

    }

    var view = this.map.getView();

    var transformedStart = this.mapService.transformCoordinates2([

      model.maxLongitude,

      model.maxLatitude,

    ]);

    var transformedEnd = this.mapService.transformCoordinates2([

      model.minLongitude,

      model.minLatitude,

    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 300,
      Math.min(transformedStart[1], transformedEnd[1]) - 300,
      Math.max(transformedStart[0], transformedEnd[0]) + 300,
      Math.max(transformedStart[1], transformedEnd[1]) + 300,
    ];

    view.fit(source);
  }

  submitUser = async () => {

    if (this.addUserForm.invalid) {
      this._other.markAllAsTouched(this.addUserForm);
      this._tooltip.showError('لطفا موارد ضروری را با دقت تکمیل کنید');
      return;

    };

    const iTanker_WaterClient = this.addUserForm.get('iTanker_WaterClient')?.value;

    if (iTanker_WaterClient) {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              let model = this.addUserForm.value;

              this._other.Showspinner();

              let res = JSON.parse((await axios.post(`Tanker_WaterClient_Edit`, this._other.stringNumberToNumber(model))).data.toString());

              this._other.nonespinner();

              if (res.ISSessionExpired == true) {

                this._tooltip.showError('لطفا وارد سیستم شوید');

                this._other.removeLocalStorage();

                this._router.navigate(['login'], { queryParams: { error: 'x12z11dx0' } });

                return;

              }

              if (res.iResult == 0) {

                return this._tooltip.showError(res.strError);

              }

              const index = this.addUserForm.get('index')?.value;

              this.lst_Clients[index] = res[0];

              this._tooltip.showSuccess('با موفقیت ویرایش شد')

              $("#addOrUpdateUser_Modal").modal('hide');
            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    else {

      let model = this.addUserForm.value;

      this._other.Showspinner();

      let res = JSON.parse((await axios.post(`Tanker_WaterClient_Save`, this._other.stringNumberToNumber(model))).data.toString());

      this._other.nonespinner();

      if (res.ISSessionExpired == true) {

        this._tooltip.showError('لطفا وارد سیستم شوید');

        this._other.removeLocalStorage();

        this._router.navigate(['login'], { queryParams: { error: 'x12z11d0' } });

        return;

      }

      if (res.iResult == 0) {

        return this._tooltip.showError(res.strError);

      }

      this.lst_Clients.push(res[0]);

      this._tooltip.showSuccess('با موفقیت ثبت شد')

      $("#addOrUpdateUser_Modal").modal('hide');

    }


  }

  getInfo = async (item: { iTanker_WaterClient: any; }): Promise<object> => {

    let model = { ...this.mdl_Search.value, iTanker_WaterClient: item.iTanker_WaterClient };

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Tanker_WaterClient_Info`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });

      return undefined;

    }

    if (res.iResult == 0) {

      this._tooltip.showError(res.strError);

      return undefined;

    }

    return res || undefined;

  }

  filterResult(strValue: string) {

    if (strValue.length > 1) {

      this.lst_Clients = this.lst_Search.filter((el: any) => {

        return el.strName.includes(strValue) ||

          el?.strTanker_WaterClientUsage_strComment.includes(strValue)

      })

    }

    else if (strValue == '') this.lst_Clients = this.lst_Search

  }

  async removeClient(item: { iTanker_WaterClient: any; }, index: number) {

    $.confirm({

      title: `آیا از حذف مشتری اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._other.Showspinner();

            let res = JSON.parse((await axios.post(`Tanker_WaterClient_Delete`, this._other.stringNumberToNumber({ ...this.mdl_Search.value, iTanker_WaterClient: item.iTanker_WaterClient }))).data.toString());

            this._other.nonespinner();

            if (res.iResult == 0 && res.strError != '') return this._tooltip.showError(res.strError);

            this.lst_Clients.splice(index, 1);

            this.lst_Search.splice(index, 1);

            this._tooltip.showSuccess('با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  showOnMap() {

    if (!this.lst_Clients.length) {
      return this._tooltip.showError('نتیجه ایی یافت نشد!');
    }

    const clients = this.lst_Clients.map(({ fCenterLat, fCenterLon, iTanker_WaterClient }) => ({
      fLat: fCenterLat,
      fLon: fCenterLon,
      strUnitID: iTanker_WaterClient
    }));

    const encryptedClients = this._gurd.encrypt(JSON.stringify(clients));
    window.localStorage.setItem('x5SBJaw', encryptedClients);

    const urlTree = this._router.createUrlTree(['emdadran', 'search-requests', 'map']);
    const serializedUrl = this._router.serializeUrl(urlTree);
    window.open(serializedUrl, '_blank');

  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'مدیریت مشتریان آب شرب.xlsx');

    }, 200);

  }

  async openDeliveryScheduleModal(item: { iTanker_WaterClient: any; }, index: number) {

    this._other.Showspinner();

    let res = await this.loadDeliverySchedule(item.iTanker_WaterClient);

    this._other.nonespinner();

    if (!res) return;

    this.deliveryScheduleForm.patchValue({
      iTanker_WaterClient: item.iTanker_WaterClient
    })

    this.assignTankerForm.patchValue({
      lstiTanker_DeliverySchedule: [],
      strUnitID: ''
    });

    this.selectedItems = [];
    this.selectAll = false;

    $("#tankerDeliveryScheduleModal").modal("show");


  }

  async loadDeliverySchedule(iTanker_WaterClient: any): Promise<any> {

    const model = this._other.stringNumberToNumber({
      ...this.mdl_Search.value,
      iTanker_WaterClient: iTanker_WaterClient
    });

    let res = JSON.parse((await axios.post(`Tanker_DeliverySchedule_List`, model)).data.toString());

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return null;
    }

    if (res.iResult == 0) {
      this._tooltip.showError(res.strError);
      return null;
    }

    this.deliveryScheduleList = res;

    return res;

  }

  showSchedulePlanner() {
    this.deliveryScheduleForm.patchValue({
      strSDate: '',
      strEDate: '',
      strDayName: '',
      strTime: '',
      iValue: '',
      strComment: ''
    });

    $("#schedulePlannerModal").modal("show");


  }

  async submitSchedulePlan() {
    this.deliveryScheduleForm.get('strTime')?.setValue($("#deliveryTime").val())
    if (this.deliveryScheduleForm.invalid) {
      this._other.markAllAsTouched(this.deliveryScheduleForm);
      this._tooltip.showError('لطفا موارد ضروری را با دقت تکمیل کنید');
      return;

    };

    const model = this._other.stringNumberToNumber(this.deliveryScheduleForm.value);
    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Tanker_DeliverySchedule_Save`, model)).data.toString());
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: 'x12z11d0' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this._tooltip.showSuccess('با موفقیت ثبت شد');
    $("#schedulePlannerModal").modal('hide');
    $("#tankerDeliveryScheduleModal").modal("hide");

  }

  setCheckBox(value: boolean, item: any) {
    if (value === true) {
      if (!this.selectedItems.includes(item.iTanker_DeliverySchedule)) {
        this.selectedItems.push(item.iTanker_DeliverySchedule);
      }
    }

    else {
      this.selectedItems.find((value: any) => {
        if (value === item.iTanker_DeliverySchedule) {
          const index = this.selectedItems.indexOf(item.iTanker_DeliverySchedule);
          if (index !== -1) this.selectedItems.splice(index, 1);
        }
      })
    }

    this.selectAll = this.deliveryScheduleList.length > 0 && this.deliveryScheduleList.every((el: any) => this.selectedItems.includes(el.iTanker_DeliverySchedule));
  }

  isSelected(item: any) {
    return this.selectedItems.includes(item.iTanker_DeliverySchedule);
  }

  toggleAll(value: boolean) {
    this.selectAll = value;
    if (value === true) {
      this.selectedItems = this.deliveryScheduleList.map((item: any) => item.iTanker_DeliverySchedule);
    } else {
      this.selectedItems = [];
    }
  }

  openDefineTankerModal() {
    if (!this.selectedItems.length) {
      this._tooltip.showError('تانکری انتخاب نشده است')
      return;
    }

    this.assignTankerForm.patchValue({
      lstiTanker_DeliverySchedule: this.selectedItems,
      strUnitID: ''
    });

    $("#defineTankerModal").modal("show");

  }

  async getTanker() {
    this._other.Showspinner()

    const model = this._other.stringNumberToNumber(this.mdl_Search.value)
    let res = JSON.parse((await axios.post('Tanker_List', model)).data.toString());

    if (res.ISSessionExpired == true) {
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '14' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this._other.nonespinner()
    this.tankerList = res;

  }

  async submitAssignTanker() {
    if (this.assignTankerForm.invalid) {
      this._other.markAllAsTouched(this.assignTankerForm);
      this._tooltip.showError('لطفا موارد ضروری را با دقت تکمیل کنید');
      return;

    };

    const model = this._other.stringNumberToNumber(this.assignTankerForm.value);
    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Tanker_DeliverySchedule_AssignTanker`, model)).data.toString());
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: 'x12z11d0' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this._tooltip.showSuccess('با موفقیت ثبت شد');

    $("#defineTankerModal").modal("hide");
    $("#tankerDeliveryScheduleModal").modal("hide");


  }

  async removeSchedule() {
    if (!this.selectedItems.length) {
      this._tooltip.showError('تانکری انتخاب نشده است')
      return;
    }

    this.assignTankerForm.patchValue({
      lstiTanker_DeliverySchedule: this.selectedItems,
    });

    $.confirm({
      title: `آیا از حذف اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        cancel: {
          text: "لغو",

        },
        ok: {
          text: "حذف",
          btnClass: 'btn-danger',
          keys: ['enter'],
          action: async () => {

            const model = this._other.stringNumberToNumber(this.assignTankerForm.value);
            this._other.Showspinner();

            let res = JSON.parse((await axios.post(`Tanker_DeliverySchedule_Delete`, model)).data.toString());
            this._other.nonespinner();

            if (res.ISSessionExpired == true) {
              this._tooltip.showError('لطفا وارد سیستم شوید');
              this._other.removeLocalStorage();
              this._router.navigate(['login'], { queryParams: { error: 'x12z11d0' } });
              return;
            }

            if (res.iResult == 0) {
              return this._tooltip.showError(res.strError);
            }

            this._tooltip.showSuccess("با موفقیت حذف شد");

            this.deliveryScheduleList = this.deliveryScheduleList.filter(
              (item: any) => !this.selectedItems.includes(item.iTanker_DeliverySchedule)
            );
            this.selectedItems = [];
            this.selectAll = false;

          }
        }
      }
    });

  }

}
